import {useAiChatSize} from '@AiChat/hooks/useAiChatSize';
import {useAiChat} from '@AiChat/providers/ai-chat.context';
import type {AiChatLayoutState} from '@AiChat/hooks/useAiChatLayout.types';

export function useAiChatLayout(): AiChatLayoutState {
  const {isSmall, isLarge} = useAiChatSize();
  const {state} = useAiChat();
  const isMobileLayout = state.isEmbedded ? isSmall : !isLarge;
  const floatsSidebarOverChat = isMobileLayout || (state.isEmbedded && !isLarge);

  return {
    isMobileLayout,
    floatsSidebarOverChat,
    showsSidebarRail: !isMobileLayout && (floatsSidebarOverChat || !state.isSidebarExpanded),
  };
}
